import { render, staticRenderFns } from "./ProductionBGIndex.vue?vue&type=template&id=0d498c90&"
import script from "./ProductionBGIndex.vue?vue&type=script&lang=js&"
export * from "./ProductionBGIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports